/**
 * URL search-param key on the Clerk OAuth callback holding
 * where a Google attempt lands if it creates the account.
 */
export const SIGN_UP_REDIRECT_PARAM = 'signUpRedirect';
